import React from "react"
import Reveal from "./Reveal.jsx"

const CARDS = [
  {
    eyebrow: "Learns your shop",
    title: "Reads everything before it touches anything.",
    body:
      "ShopShift renders your shop the way a customer would, builds a profile of voice, products, conversion paths, and brand identity, then writes that profile into every prompt the AI sees.",
  },
  {
    eyebrow: "Proposes experiments",
    title: "Walks the funnel, finds where it bleeds.",
    body:
      "Step-by-step diagnosis of where visitors drop off — then research, brainstorm, and concrete proposals scoped to exactly what you've authorized the AI to change. Nothing more.",
  },
  {
    eyebrow: "Picks winners",
    title: "Bayesian math, not gut feeling.",
    body:
      "When the probability of beating control crosses 95%, the winner is declared. It stays live. Losers retire. The AI keeps proposing the next test, around the clock.",
  },
]

export default function WhatItDoes() {
  return (
    <section className="border-t border-[color:var(--color-rule)] bg-[color:var(--color-surface-page)]">
      <div className="max-w-6xl mx-auto px-6 py-24">
        <Reveal>
          <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-[color:var(--color-ai)] mb-4">
            § 03 · What it does
          </p>
          <h2 className="font-sans text-[40px] tracking-[-0.035em] font-medium leading-[1.1] max-w-2xl">
            Three things, in the background, every day.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-[color:var(--color-rule)] border border-[color:var(--color-rule)] rounded-[var(--radius-card-lg)] overflow-hidden">
          {CARDS.map((card, idx) => (
            <Reveal key={card.eyebrow} delay={idx * 120}>
              <div className="bg-[color:var(--color-surface-card)] p-10 h-full flex flex-col gap-5">
                <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-[color:var(--color-ink-tertiary)]">
                  {String(idx + 1).padStart(2, "0")} · {card.eyebrow}
                </p>
                <h3 className="font-sans text-[22px] tracking-[-0.025em] font-medium leading-[1.2] text-[color:var(--color-ink-primary)]">
                  {card.title}
                </h3>
                <p className="font-sans text-[14px] text-[color:var(--color-ink-secondary)] leading-[1.6]">
                  {card.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
